import styled from '@emotion/styled';
import { Color } from '../../../../styles/Color';
import { PoiListScope } from '../domain/models/PoiListScope';
import { Css, ITheme, Responsive } from '../../../../ui';

interface IShopDineRelaxScopeToggleItemProps {
	scope: PoiListScope;
	label: string;
	activeScope: PoiListScope;
	onClick: (scope: PoiListScope) => void;
}

export default function ShopDineRelaxScopeToggleItem({
	scope,
	label,
	activeScope,
	onClick,
}: IShopDineRelaxScopeToggleItemProps) {
	return (
		<li className="no-max-width">
			<ToggleButton
				onClick={() => onClick(scope)}
				aria-label={scope === PoiListScope.All ? 'View all' : `View ${label}`}
				aria-current={activeScope === scope ? 'page' : undefined}
			>
				<h4>{label}</h4>
			</ToggleButton>
		</li>
	);
}

const ToggleButton = styled.button<{}, ITheme>`
	background: none;
	border: none;
	padding: 0;
	font-family: inherit;
	text-decoration: none;
	cursor: pointer;

	h4 {
		margin: 0;
		color: ${Color.Neutral6};
		font-size: ${Css.pxToRem(32)};
	}

	&[aria-current='page'] {
		h4 {
			border-bottom: 2px solid ${(props) => props.theme.color.secondaryLight};
			color: ${(props) => props.theme.color.secondaryLight};
		}
	}

	&:active,
	&:hover {
		h4 {
			color: ${(props) => props.theme.color.secondaryLight};
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		h4 {
			font-size: ${Css.pxToRem(24)};
		}
	}
`;
